<template>
<div class="big">
  <button class="dayin" v-print="'#dayin'">打印</button>
  <div class="tab" id="dayin">
    <div class="tab_title2">个人健康信息申报卡</div>
    <div class="i_content">
      <div class="mt20 frow">
        <div class="w33">姓名：______________</div>
        <div class="w33">性别：男□&nbsp;女□</div>
        <div class="w33">年龄：_____ 岁</div>
      </div>
      <div class="mt20 frow">
        <div class="w50">住址：______________________</div>
        <div class="w50">工作单位：__________________</div>
      </div>
      <div class="mt20 frow">
        <div class="w60">联系方式：__________________</div>
      </div>
      <div class="line"><span class="fbold">1</span>.近<span class="fbold">14</span>天是否有境外或港台地区旅居史：是□&nbsp;否□ ，如有请注明国家（地区）__________________入境时间：______年____月____日</div>
      <div class="line"><span class="fbold">2</span>.近<span class="fbold">7</span>天是否有境内中高风险地区旅居史：是□&nbsp;否□</div>
      <div class="line"><span class="fbold">3</span>.近<span class="fbold">7</span>天是否有境内中高风险地区所在城市旅居史：是□&nbsp;否□，如有请注明城市：____________市____________区，最后离开风险地区所在城市的时间为：__________________ </div>
      <div class="line"><span class="fbold">4</span>.近<span class="fbold">7</span>天是否接触过来自中高风险地区的亲属、朋友：是□&nbsp;否□</div>
      <div class="line"><span class="fbold">5</span>.近<span class="fbold">7</span>天是否接触过可疑病例及发热病人：是□&nbsp;否□</div>
      <div class="line"><span class="fbold">6</span>.近<span class="fbold">7</span>天是否有家人、朋友发热或患肺炎等疾病：是□&nbsp;否□</div>
      <div class="line"><span class="fbold">7</span>.是否曾经诊断为新冠肺炎病例、无症状感染者：是□&nbsp;否□</div>
      <div class="line"><span class="fbold">8</span>.是否全程接种新冠疫苗：是□&nbsp;否□</div>
      <div class="line"><span class="fbold">9</span>.近<span class="fbold">7</span>天您本人是否有如下症状：
发热□&nbsp;咳嗽□&nbsp;寒战□&nbsp;鼻塞□&nbsp;流涕□&nbsp;咽痛□&nbsp;头痛□&nbsp;嗅（味）觉减退□ &nbsp;
乏力□&nbsp;肌肉酸痛□&nbsp;关节酸痛□&nbsp;胸闷□&nbsp;气促呼吸困难□&nbsp;结膜充血□&nbsp;恶心□呕吐□&nbsp;腹泻□&nbsp;腹痛□&nbsp;或有其他需要说明的身体不适症状 
□经核，本人均无上述相关情况</div>
      <div class="line"><span class="fbold">10</span>.健康码：&nbsp;□绿色&nbsp;□黄色&nbsp;□红色</div>
      <div class="line"><span class="fbold">11</span>.行程码：&nbsp;□无外省城市旅居史&nbsp;□有外省城市旅居史__________________</div>
      <div class="line2">本人承诺：如实填写上述内容，自觉履行疫情防控的法律法规义务，承担相应的法律法规责任。</div>
      <div class="frow mt10">
        <div class="line w50">填表人（签字）：____________</div>
        <div class="line w50">填表日期：______年____月____日</div>
      </div>
      <div class="line tunderline fbold">1.请在对应的方框内打“√”。2.本表请交相关联络员收集汇总。</div>
    </div>
  </div>
</div>
  
  
</template>

<script>
import $ from 'jquery'
export default {
  name: 'Search',
  data () {
    return {

    }
  },
  methods:{
    preview(id) {
        var sprnhtml = $('#' + id).html(); //获取区域内容
        var selfhtml = $('body').html(); //获取当前页的html, 用来恢复页面
        //设置整个页面为要打印的内容。
        $('body').html(sprnhtml);
        //打印预览整个页面。
        window.print();
        //恢复整个页面到打印前的内容。
        $('body').html(selfhtml);
    },

    
  },
  mounted() {
    
  },
  created(){

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .dayin{
    width:100px;
    height:30px;
    line-height:30px;
    border-radius:5px;
    border:none;
    text-align: center;
    background:#1B8BFB;
    color:white;
    position: fixed;
    right:10px;
    cursor: pointer;
  }
  .line{
    line-height:25px;
    margin:10px 0;
  }
  .line2{
    margin-top:20px;
    text-indent: 2em;
    line-height:25px;
  }
  .tunderline{
    border-bottom:1px solid #7F7F7F;
  }
  .new_title{
    text-align: center;
    font-size:16px;
    line-height:25px;
  }
  
  .tab{
    width:90%;
    margin:10px auto;
    /* border:1px solid black; */
    height:auto;
    color:#383838;
    padding:10px 0;
    font-family: "宋体";
  }
  .i_content{
    width:95%;
    margin:0 auto;
    text-align: justify;
    font-size:18px;
 }
 .tab_title2{
    font-size:25px;
    line-height:45px;
    text-align: center;
    font-weight: bold;
    margin-top:20px;
    margin-bottom:40px;
 }
 .tab_content{
    width:94%;
    font-size:15px;
    margin:10px auto;
 }
 .tab_left{
    width:72%;
 }
 .tab_line{
    line-height:25px;
 }
 .tab_img{
    width:28%;
    height:180px;
    border:1px solid black;
    display: flex;
    justify-content: center;
    align-items: center;
    padding:2px;
 }
 .tab_img img{
  width:90%;
 }
 
 .tb{
    border-bottom:1px solid black;
    min-height:35px;
 }
 .tab_c1{
    text-align: center;
    font-size:13px;
    line-height:35px;
    border-right:1px solid black;
    min-width:25%;
 }
 .tab_c2{
    text-align: left;
    font-size:13px;
    padding-left:5px;
    line-height:35px;
 }
 .per_img{
    width:95%;
 }
 .tab_last{
    min-height:40px;
    line-height:25px;
    font-size:13px;
    margin-top:5px;
 }
 .tl_1{
    width:25%;
    text-align: center;
 }
 .tl_2{
    width:45%;
    text-align: center;
 }
 .tl_3{
    width:15%;
    text-align: center;
 }
 .tl_4{
    width:15%;
    text-align: center;
 }
</style>



// WEBPACK FOOTER //
// src/components/Safe.vue